import { OfferActionTypes, All } from '../actions/offer.actions';
import { Offer } from '@app/shared/models/offer';
import { OfferAllocation } from '@app/shared/models/offerAllocation';
import { OfferType } from '@app/shared/models/offerType';
import { RequestStatus } from '@app/shared/models/requestStatus';

// define State interface
export interface State {
  // is a user authenticated?
  selectedOffer: Offer | null;
  allocation:OfferAllocation | null;
  // if authenticated, there should be a user object
  offers: Offer[] | null;
  errorStatus: RequestStatus | null;
  isEditing: boolean | null;
  actionType: string | null;
  favourites: Offer[] | null;
  offerTypes: OfferType[] | null;
  inactiveOfferTypes: OfferType[] | null;
  successStatus: RequestStatus | null;
  showVendorUpload:boolean | null;
  hssCodes:any[] | null;
  themes:any[] | null;
  fields:any[] | null;
  preferences:any[] | null;
}

// define initial state
export const initialState: State = {

  selectedOffer: null,
  allocation:null,
  offers: null,
  errorStatus: null,
  isEditing:false,
  actionType:null,
  favourites:null,
  successStatus:null,
  offerTypes:null,
  inactiveOfferTypes:null,
  showVendorUpload:null,
  hssCodes:null,
  themes:null,
  fields:null,
  preferences:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case OfferActionTypes.GET_OFFERS_SUCCESS: {
      return {
        ...state,
        selectedOffer: null,
        showVendorUpload:null,
        offers: action.payload.offers,
        errorStatus:null,
        actionType:action.type,
      };
    }
    case OfferActionTypes.GET_OFFER_HISTORY_SUCCESS:
    case OfferActionTypes.GET_OFFER_SUCCESS:
    case OfferActionTypes.SET_OFFER: {
      return {
        ...state,
        selectedOffer: action.payload.offer,
        actionType:action.type,
      };
    }

    case OfferActionTypes.INGEST_OFFERS: {
      return {
        ...state,
        actionType:action.type,
      };
    }
    case OfferActionTypes.ADD_MEDIA: {
      return {
        ...state,
        actionType:action.type,
      };
    }
    case OfferActionTypes.CREATE_OFFER:
    case OfferActionTypes.EDIT_OFFER: {
      return {
        ...state,
        selectedOffer: action.payload.offer,
        isEditing: action.payload.isEditing,
        showVendorUpload:null,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }
    case OfferActionTypes.GET_FAVE_OFFERS_SUCCESS: {
      return {
        ...state,
        favourites: action.payload.offers,
        actionType:action.type,
      }

    }
    case OfferActionTypes.GET_OFFER_TYPES_SUCCESS: {
      return {
        ...state,
        offerTypes: action.payload.offerTypes,
        actionType:action.type,
      }
    }
    case OfferActionTypes.GET_INACTIVE_OFFER_TYPE_SUCCESS: {
      return {
        ...state,
        inactiveOfferTypes: action.payload.inactiveOfferTypes,
        actionType:action.type,
      }
    }
    case OfferActionTypes.GET_HSS_CODES_SUCCESS: {
      return {
        ...state,
        hssCodes: action.payload.hssCodes,
        actionType:action.type,
      }
    }
    case OfferActionTypes.GET_ALT_FIELDS_SUCCESS: {
      return {
        ...state,
        themes: action.payload.altFields,
        actionType:action.type,
      }
    }
    case OfferActionTypes.GET_FIELDS_SUCCESS: {
      return {
        ...state,
        fields: action.payload.fields,
        actionType:action.type,
      }
    }
    case OfferActionTypes.GET_PREFERENCES_SUCCESS: {	
      return {	
        ...state,		
        actionType:action.type,	
        preferences: action.payload.preferences,
      }	
    }
    case OfferActionTypes.SET_OFFER_LOCK_SUCCESS:
    case OfferActionTypes.REMOVE_ALLOCATION_SUCCESS:
    case OfferActionTypes.MOVE_ALLOCATION_SUCCESS:
    case OfferActionTypes.BATCH_UPDATE_OFFER_SUCCESS:
    case OfferActionTypes.UPDATE_FAVE_OFFERS_SUCCESS: {
      return {
        ...state,
        //favourites: action.payload.favourites,
        showVendorUpload:null,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      }

    }

    case OfferActionTypes.UPDATE_OFFER_SUCCESS: {
      return {
        ...state,
        selectedOffer: action.payload.offer,
        allocation:action.payload.allocation,
        successStatus:action.payload.successStatus,
        showVendorUpload:action.payload.showVendorUpload,
        actionType:action.type,
      }

    }
    case OfferActionTypes.ADD_MEDIA_SUCCESS:
    case OfferActionTypes.COPY_OFFER_SUCCESS:
    case OfferActionTypes.MOVE_OFFER_SUCCESS:
    case OfferActionTypes.SWAP_OFFERS_SUCCESS:
    case OfferActionTypes.ALLOCATE_OFFER_SUCCESS:
    case OfferActionTypes.UNALLOCATE_OFFER_SUCCESS:
    case OfferActionTypes.ALLOCATE_FAVE_OFFER_SUCCESS:
    case OfferActionTypes.ASSIGN_OFFER_SUCCESS: {
      return {
        ...state,
        //favourites: action.payload.favourites,
        showVendorUpload:null,
        successStatus:action.payload.successStatus,
        actionType:action.type,
        errorStatus:null,
      }

    }
    case OfferActionTypes.ADD_MEDIA_FAILURE:
    case OfferActionTypes.UNALLOCATE_OFFER_FAILURE:
    case OfferActionTypes.UPDATE_FAVE_OFFERS_FAILURE:
    case OfferActionTypes.SET_OFFER_LOCK_FAILURE:
    case OfferActionTypes.MOVE_ALLOCATION_FAILURE:
    case OfferActionTypes.REMOVE_ALLOCATION_FAILURE:
    case OfferActionTypes.BATCH_UPDATE_OFFER_FAILURE:
    case OfferActionTypes.UPDATE_OFFER_FAILURE:
    case OfferActionTypes.GET_OFFER_TYPES_FAILURE:
    case OfferActionTypes.GET_OFFER_FAILURE:
    case OfferActionTypes.ASSIGN_OFFER_FAILURE:
    case OfferActionTypes.ALLOCATE_FAVE_OFFER_FAILURE:
    case OfferActionTypes.MOVE_OFFER_FAILURE:
    case OfferActionTypes.COPY_OFFER_FAILURE:
    case OfferActionTypes.SET_OFFER_FAILURE:
    case OfferActionTypes.GET_OFFERS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.errorStatus,
        successStatus:null,
        actionType:action.type,
      };
    }
    default: {
      return {
        ...state,
        actionType:null,
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/offer.reducer.ts